// faqStrings.ts
import  React  from "react";
import { ReactNode } from "react";
import { Container, Row, Col, Image } from 'react-bootstrap';


import { IAppConfig, AppConfig, IAddress,IFAQDataDoc_v2_WithSUB,  IFAQDataDoc, IFaqItem, IImagePath, 
          IPageContactUs,
          CompanyAddress, IOperatingHours, OperatingHours, 
          IPageAbout} from "../App_v01_Interfaces";


const mOperatingHours: IOperatingHours = 
  new OperatingHours("Mon–Fri: 8am – 6pm", "Sat: 9am – 3pm", "Sun: Call hotline number on your machine")

const mAddress : IAddress = new CompanyAddress("1312 17th St", "Suite: 364", "Denver", "CO", "80202")


  
export const faqData: IFAQDataDoc_v2_WithSUB = 
{
  title:"",
  items:

[
    {
      category: 'General Questions',
      icon: 'bi-cup-straw',
      items: [
        {
          question: 'What types of products do your vending machines offer?',
          answer: 'Snacks, drinks, healthy and customizable options.'
        },
        {
          question: 'Are your machines ADA-compliant and modern?',
          answer: 'Yes, with cashless payments and real-time monitoring.'
        },
        {
            question: 'What are ADA-compliant vending machines?',
            answer: 'The Americans with Disabilities Act Standards for Accessible Design.  Therefore, an ADA compliant vending machine must be accessible to those with disabilities.'
            
          },
        {
          question: 'Do you offer healthy or specialty vending options?',
          answer: 'Yes, including organic, gluten-free, and keto choices.'
        }
      ]
    },
    {
      category: 'For Business Owners & Property Managers',
      icon: 'bi-building',
      items: [
        {
          question: 'What does it cost to install a vending machine?',
          answer: "It is free - The machine delivery, installation, and service is provided at no cost to the property.  Vending drinks and snacks at fair prices, provides a safe and convenient value added amenity for everyone who visits your property."
        },
        {
          question: 'How do I qualify?',
          answer: 'We will provide a free evaluation your site to see what machine / design services your visitors best.'
        },
        {
          question: 'Who maintains the machines?',
          answer: 'We do.  Maintenance, repairs, and refills are included in the service.'
        },
        {
            question: 'What types of machines are provided?',
            answer: 'We only work with new machines that utilize the latest technology to monitor the inventory and health status of the machine in real time.'
          }
      ]
    },
    {
      category: 'Service & Support',
      icon: 'bi-tools',
      items: [
        {
          question: 'What if the machine breaks?',
          answer: 'We always monitoring the machine via the internet.  We strive to resolve most issues within 24 hours.'
        },
        {
          question: 'What if someone loses money?',
          answer: 'We offer full refunds.  We will corrdinate with your manager and/or we offer refunds via phone and/or online form.'
        }
      ]
    },
    {
      category: 'Still Have Questions?',
      icon: 'bi-envelope-paper-heart',
      items: [
        {
          question: 'More questions',
          answer: <span>Contact us using the <a href='/contact'>contact us form</a> on this website.  We’re happy to help!</span>
        }
      ]
    }
]
};

  

export const Page_ContactUs_Data: IPageContactUs = {
    Headline :  <>
                  <h2>Contact Us</h2>
                  <p>
                    Whether you need vending machines, a custom micro market, or just want to learn more — we’d love to
                    hear from you!  &nbsp;<i className="bi bi-emoji-smile fs-3 text-success"></i>
                  </p>
                </>
}


export const Page_About_Data: IPageAbout = {
  Headline: 
              <Row className="mb-4">
                <Col md={6}>
                    <h2>About us... &nbsp;<i className="bi bi-emoji-smile fs-3 text-success"></i></h2>
                      <p>
                        We offer modern, high-quality vending solutions tailored for today’s
                        workplaces, schools, gyms, and public spaces. Our services range from drink and snack machines to
                        micro markets, premium coffee and customized healthy food solutions.
                      </p>
                      <p>
                        With cutting-edge inventory tracking, 24/7 machine uptime, and a customer-first approach, we make
                        vending effortless for organizations and delightful for users.
                      </p>

                </Col>
                <Col md={6}>
                  {/* <Image
                    src="/images/sundance-dancer-logo.png" // replace with actual logo/image path
                    alt="Sundance Vending Company Logo"
                    fluid
                    className="rounded"
                  /> */}
                </Col>
              </Row>,

  Services:   <Row>
                <Col md={4}>
                  <h5>Advanced Vending Solutions</h5>
                  <ul>
                    <li>Smart vending tech with remote monitoring</li>
                    <li>Customized product selections</li>
                    <li>Cashless & contactless payments</li>
                    <li>Energy-efficient, modern machines</li>
                  </ul>
                </Col>

                <Col md={4}>
                  <h5>Our Services</h5>
                  <ul>
                    <li>Drink & Snack Machines</li>
                    <li>Combo Machines</li>
                    <li>Micro Markets</li>
                    <li>Custom Branding</li>
                  </ul>
                </Col>

                <Col md={4}>
                  <h5>Service Areas</h5>
                  <ul>
                    <li>Corporate Offices</li>
                    <li>Schools & Universities</li>
                    <li>Fitness Centers</li>
                    <li>Industrial & Public Facilities</li>
                    <li>Warehouse & Manufacturing</li>
                    <li>Medical & Veterinary</li>

      

                  </ul>
                </Col>
              </Row>
}


const mImagePaths: IImagePath[] = [
  {imageName:"NavBarLogoDeskTop", imagePath:"/sundance-images/"},
  {imageName:"NavBarLogoPhone",   imagePath: "/sundance-images/"},
]//end:

// VERSION INFO
export const AppConfigData : IAppConfig = new AppConfig(
  "v03J", 
  "Sundance Vending",
  "Sundance Vending LLC", 
  '(720) 927-7141', 
  "info@sundanceVending.com", 
  "support@sundancevending.com", 
  "(720) 927-7141", 
  "website.legal@SundanceVending.com", 
  "https://wi8zkeven2.execute-api.us-east-1.amazonaws.com/prod/feedback",
    mAddress, 
    mOperatingHours, 
    mImagePaths,
    faqData,
    Page_ContactUs_Data,
    Page_About_Data,
      null, null, null, null, null, 1)



// export const AppConfig_DATA : IAppConfig = new AppConfig(
//   "v00a", "Legacy Insurance",
//   "Legacy Insurace LLC", 
//   '(720) 927-7141', 
//   "info@LegacyInsurance.com",   
//   "support@LegacyInsurance.com", 
//   "(720) 927-7141", 
//   "website.legal@LegacyInsurance.com", 
//   "https://wi8zkeven2.execute-api.us-east-1.amazonaws.com/prod/feedback",
//     mAddress, 
//     mOperatingHours, 
//     mImagePaths,
//     FAQ_Page_DATA,
//     Page_ContactUs_DATA,
//     Page_About_DATA,

//     homePage_01_carouselItems_DATA,
    
//                                   // homePage_02_FeatureList_DATA,
//                                   // homePage_02_FeatureList_Categories_DATA,
//                                   InsuranceTypesList,
//     homePage_03_metricsRow_DATA,
    

//     BizInsurnaceServices_DATA,
//     PersonalInsurnaceServices_DATA,
//     2
//   )//end:


















export const homePage_carouselItems_Vending = [
  {
    
    alt: 'Fresh and Cold',
    Title: 'Fresh, Cold/Hot and satisfying',
    Description: 'Fresh snacks and cold drinks are an awesome benefit to everyone who visits your property.',
    src: '/sundance-images/IMG-VendingMachind01-unsplash.jpg',
  },
  {
    
    alt: 'Safe and affordiable',
    Title: 'Safe and affordiable',
    Description: 'Safe, affordiable and valueable benefit to you employees, customers and suppliers',
    src: '/sundance-images/IMG-VENDING-MACHINE-02-AdobeStock_1081809176_Editorial_Use_Only.jpg',
  },
  {
    
    alt: 'High Tech',
    Title: 'High Tech / High Touch',
    Description: 'The latest technology in vending & Micro markets / Internet & AI aware',
    src: '/sundance-images/IMG-AI-VENDING-01-AdobeStock_1008969090.jpg',
  },
  {
    
    alt: 'Refreshing',
    Title: 'Refreshing',
    Description: 'Refresh and recharge in your break room - improving employee productivity and satisfaction.',
    src: '/sundance-images/IMG-BREAK-ROOM-AdobeStock_1082705275.jpg',
  },
];


